import React from 'react'

import { IconProps } from './types'

const ExclamationCircle: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke={color}
    width={size}
    height={size}
    {...rest}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
)

ExclamationCircle.displayName = 'ExclamationCircle'
ExclamationCircle.defaultProps = {
  size: 24,
  color: 'currentColor',
}

export default ExclamationCircle
